function getDataAttributes(value: string, prefix?: string): string {
  if (prefix) return `${prefix}-${value}`

  return value
}

export default getDataAttributes
